import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggerAbstractService, LogLevel } from 'bqx-logging';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { IBecaRequest } from 'src/app/models/beca/beca-request.model';
import { AbstractAuthService } from '../auth/auth.abstract.service';
import { SecondaryDataAbstractService } from './secondary-data.abstract.service';

@Injectable({
  providedIn: 'root'
})
export class SecondaryDataService implements SecondaryDataAbstractService {
  private _lastFinalClassification: string; //  The last request.FinalWatsonIndexEntry value
  private _secondaryData: IBecaRequest;
  private _isFallback: boolean;

  public set lastFinalClassification(val: string) {
    this._lastFinalClassification = val;
  }
  public set secondaryData(data: IBecaRequest) {
    this._secondaryData = data;
  }

  public get secondaryData(): IBecaRequest {
    return this._secondaryData;
  }

  public set isFallback(data: boolean) {
    this._isFallback = data;
  }

  public get isSaveDataAllowed(): boolean {
    return !this._isFallback &&
      this._secondaryData?.FinalWatsonIndexEntry &&
      this._secondaryData?.FinalWatsonIndexEntry !== this._lastFinalClassification;
  }

  constructor(
    private http: HttpClient,
    private authService: AbstractAuthService,
    private loggerService: LoggerAbstractService,
  ) { }

  private logMissingBecaFields(becaRequest): void {
    const missingRequiredBecaFields = ['Applicationid', 'WatsonConversationId', 'FinalWatsonIndexEntry', 'BECAInput', 'BECALabel'].filter(
      (field) => !becaRequest[field]
    );

    if (missingRequiredBecaFields.length > 0) {
      const error = {
        missingFields: missingRequiredBecaFields.join(', '),
        becaRequest: becaRequest,
        quoteNumber: becaRequest.Applicationid
      };
      this.loggerService.postLogData(LogLevel.Error, 'secondary-data-service: saveSecondaryData', JSON.stringify(error));
    }
  }

  public saveSecondaryData(appFormId: string): Observable<any> {
    const getHeaders: HttpHeaders = new HttpHeaders({
      'content-Type': 'application/json',
      Authorization: 'Bearer ' + this.authService.accessToken
    });
    this._secondaryData.Applicationid = appFormId;
    this._lastFinalClassification = this._secondaryData.FinalWatsonIndexEntry;
    this.logMissingBecaFields(this._secondaryData);
    return this.http.post<any>(AppConfig.settings.s3Put.lambdaUrl, JSON.stringify(this._secondaryData), {
      headers: getHeaders,
      responseType: 'json'
    });
  }
}
